import Immutable from "immutable";
import { call, select, put, take } from "redux-saga/effects";

import {
  getDinnerBookingByID,
  getDinnerBookingBasketPrice,
  getDinnerBookingSelectedOptionIDList,
  isDinnersReady,
  getBasketItemsOfType
} from "state/school_money/selectors";
import {
  setBasketItem,
  deleteBasketItem
} from "state/school_money/actions";

import validateBasketItem from "state/school_money/sagas/basketSaga/dinnerBooking/validateBasketItem";

export function* addToBasket(action) {
  const { dinnerBookingID } = action.payload;
  
  const dinnerBooking = yield select(getDinnerBookingByID, dinnerBookingID);
  const { schoolID, studentID } = dinnerBooking.toObject();
  const price = yield select(getDinnerBookingBasketPrice, dinnerBookingID);
  const optionIDs = yield select(getDinnerBookingSelectedOptionIDList, dinnerBookingID);
  const payload = { dinnerBookingID, dinnerBooking, optionIDs };
  
  yield put(setBasketItem("dinnerBooking", dinnerBookingID, schoolID, studentID, dinnerBookingID, price, 1, payload));
  
}

export function* removeFromBasket(action) {
  const { dinnerBookingID } = action.payload;
  yield put(deleteBasketItem("dinnerBooking", dinnerBookingID));
}

export function* detectBasketItemsIssues() {
  
  // wait for payments to be loaded
  while (!(yield select(isDinnersReady))) {
    yield take();
  }
  
  // get relevant state
  const basketItems = yield select(getBasketItemsOfType, "dinnerBooking");
  
  // build up a list of issues
  let issues = Immutable.List();
  for (const basketItem of basketItems) {
    const issue = yield call(validateBasketItem, basketItem);
    if (issue) {
      issues = issues.push(issue);
    }
  }
  
  return issues;
  
}

export function* resolveBasketItemsIssues(issues) {
  
  if (issues === undefined) {
    return;
  }
  
  // delete basket items that caused issues
  for (const issue of issues) {
    yield put(deleteBasketItem("dinnerBooking", issue.get("basketItemID")));
  }
  
}



// WEBPACK FOOTER //
// ./src/state/school_money/sagas/basketSaga/dinnerBooking/index.js